import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/system_integration",
  name: "system_integration",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration");
  },
  meta: {
    title: "系统对接",
    foot: true
  }
}, {
  path: "/system_integration/formPage/:sn?",
  name: "system_integration_formPage",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_formPage");
  },
  meta: {
    title: "填写信息",
    foot: true
  }
}, {
  path: "/system_integration/verify/:sn?",
  name: "system_integration_verify",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_formPage");
  },
  meta: {
    title: "身份信息核对",
    foot: true
  }
}, {
  path: "/system_integration/edit/:sn?",
  name: "system_integration_edit",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_formPage");
  },
  meta: {
    title: "修改信息",
    foot: true
  }
}, {
  path: "/system_integration_member",
  name: "system_integration_member",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_member");
  },
  meta: {
    title: "系统对接",
    foot: true
  }
}, {
  path: "/system_integration_report",
  name: "system_integration_report",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_report");
  },
  meta: {
    title: "检测报告",
    foot: true
  }
}, {
  path: "/system_integration_search",
  name: "system_integration_search",
  component: function component() {
    return import("../../../views/search");
  },
  meta: {
    title: "搜索",
    foot: true
  }
}, {
  path: "/system_integration_Frequencydetail",
  name: "system_integration_Frequencydetail",
  component: function component() {
    return import("../../../views/bodyHealthCheck/system_integration_Frequencydetail");
  },
  meta: {
    title: "次数明细",
    foot: true
  }
}];